import styles from '../PropertyPanel.module.css';

function TextField({ label, value, onChange, multiline = false }) {
  if (multiline) {
    return (
      <label className={styles.field}>
        <span className={styles.fieldLabel}>{label}</span>
        <textarea
          className={styles.textarea}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          rows={3}
        />
      </label>
    );
  }

  return (
    <label className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <input
        type="text"
        className={styles.input}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  );
}

export default TextField;
